module.exports = __webpack_public_path__ + "img/foot-channel11.47af3760.png";